export const ASSETS_S3_URL = 'https://s3.amazonaws.com/assets.inkive.com/';

export function getEnvironment () {
  if (INKIVE.C.BASE_URL.match('/desygner')) {
    return 'production';
  } else if (INKIVE.C.BASE_URL.match('/builddesygner')) {
    return 'build';
  } else if (INKIVE.C.BASE_URL.match('/qadesygner')) {
    return 'qa';
  } else if (INKIVE.C.BASE_URL.match('/makedesygner')) {
    return 'develop';
  } else if (INKIVE.C.BASE_URL.match('/localhost')) {
    return 'proxy';
  }

  return 'production';
}

export function getAssetsDomain () {
  switch (getEnvironment()) {
    case 'production': return INKIVE.C.STATIC_URL;
    case 'build': return ASSETS_S3_URL;
    case 'qa': return ASSETS_S3_URL;
    case 'develop': return INKIVE.C.BASE_URL;
    case 'proxy': return INKIVE.C.BASE_URL;
    default: return INKIVE.C.BASE_URL;
  }
}

export function getAssetsUrl (fileName, baseUrl, relativePath = 'assets/build/') {
  const env = getEnvironment();
  const domain = baseUrl || getAssetsDomain(env);
  const version = (!INKIVE.C.IS_DEV && INKIVE.C.VERSION && INKIVE.C.VERSION !== 'develop')
    ? `${INKIVE.C.VERSION}/`
    : '';

  return `${domain}${relativePath}${version}${fileName}`;
}
